import React from 'react'
import styled from 'styled-components';
import mountainMask from '../../assets/MountainMask.png';

const Styles = styled.div`
    #about {
        width: 100%;
        height: 100vh;
        /* object-fit: cover; */
        max-height: 100vh;
        background-color: white;
        z-index: -2;
        position: absolute;
    }
    
    .mountainMask {
        background-image: url(${mountainMask});
        background-repeat: no-repeat;
        
        width: 100%;
        height: 100vh;
        max-width: 100vw;
        overflow: hidden;
        
        /* background-position: top; */
        rotate: 180deg;
        transform: scaleX(-1);
        position: absolute;
        background-size: cover;
        /* top: -1vh; */
        /* bottom: 0; */
        /* margin: 0 auto; */
        z-index: -1;
    }
    
`;

class About extends React.Component {
    render() {
        return (
            <Styles>
                <div id='about'>
                    <div class="mountainMask"></div>

                    <span>This is a span in the about section</span>
                    <a href='#portfolio'>Portfolio page</a>
                    <a href='#hero'>Hero page</a>

                </div>

            </Styles>

        )
    }
}

export default About;
